import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.MediaFile.GetFile.IRequest;
type Response = Api.Core.MediaFile.GetFile.IResponse;
type Headers = Api.Core.MediaFile.GetFile.IHeaders;
const url = '/api/MediaFile/:id';
export default async function mediaFileGetFileApi(params?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
    keepRawResponse: true,
  });
  return serverResponse;
}
